"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockKeep3rV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockKeep3rV1Factory = /** @class */ (function (_super) {
    __extends(MockKeep3rV1Factory, _super);
    function MockKeep3rV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockKeep3rV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockKeep3rV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockKeep3rV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockKeep3rV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockKeep3rV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockKeep3rV1Factory;
}(contracts_1.ContractFactory));
exports.MockKeep3rV1Factory = MockKeep3rV1Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "credit",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "job",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "keeper",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "block",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "KeeperWorked",
        type: "event",
    },
    {
        constant: false,
        inputs: [],
        name: "activate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_keeper",
                type: "address",
            },
        ],
        name: "isKeeper",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "keeper",
                type: "address",
            },
        ],
        name: "worked",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610234806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80630f15f4c0146100465780635feeb794146100505780636ba42aaa14610063575b600080fd5b61004e61008c565b005b61004e61005e366004610139565b6100a8565b610076610071366004610139565b61010a565b6040516100839190610180565b60405180910390f35b336000908152602081905260409020805460ff19166001179055565b806001600160a01b0316336001600160a01b0316306001600160a01b03167f3cda93551ad083704be19fabbd7c3eb94d88f6e72ff221bdea9017e52e4144e843670de0b6b3a76400006040516100ff92919061018e565b60405180910390a450565b6001600160a01b031660009081526020819052604090205460ff1690565b8035610133816101da565b92915050565b60006020828403121561014b57600080fd5b60006101578484610128565b949350505050565b610168816101bb565b82525050565b610168816101cf565b610168816101cc565b60208101610133828461015f565b6040810161019c8285610177565b6101a9602083018461016e565b9392505050565b6000610133826101c0565b151590565b6001600160a01b031690565b90565b6000610133826101cc565b6101e3816101b0565b81146101ee57600080fd5b5056fea365627a7a72315820421d9f86e8868f98b3aff05230e5b8dd90e0dfaa0ecdb92a37c2f3cce32675c06c6578706572696d656e74616cf564736f6c63430005100040";
//# sourceMappingURL=MockKeep3rV1Factory.js.map